<template>
    <div class="navbar">
        <nav class="deep-purple darken-1">
            <div class="container">
                <router-link :to="{name:'GMap'}" class="brand-logo left">Appricot Geo</router-link>
                <ul class="right">
                    <!-- leave space before colon with to or cause an error -->
                    <li v-if="!user"><router-link :to="{name:'Signup'}">Signup</router-link></li>
                    <li v-if="!user"><router-link :to="{name:'Login'}">Login</router-link></li>
                    <li v-if="user"><a>{{user.email}}</a></li>
                    <li v-if="user"><a @click="logout">Logout</a></li>
                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
import firebase from 'firebase'
export default {
    name:'Navbar',
    data() {
        return {
            user: null
        }
    },
    methods: {
        logout() {
            firebase.auth().signOut().then(()=>{this.$router.push({name:'Login'})})
        }
    },
    created() {
        //this function will fire each time status changes onAuthStateChanged then a call back functon while passing parameter user
        firebase.auth().onAuthStateChanged((user)=>{
            if (user) {
                this.user= user
            } else {
                this.user= user
            }
        })    
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar.vue